export default "__VITE_ASSET__ClJaRtIL__"